function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

function fmtMoney(n) {
  if (n == null) return "—";
  return `${Number(n).toLocaleString("es-ES", { minimumFractionDigits: 2 })} €`;
}

export default function BajasTab({ bajas }) {
  if (bajas.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">Este alumno no tiene bajas registradas</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">
        {bajas.length} baja{bajas.length !== 1 ? "s" : ""}
        {bajas.filter((b) => b.resultado === "Recuperado").length > 0 && (
          <span className="ml-2 text-emerald-600 font-medium">
            ({bajas.filter((b) => b.resultado === "Recuperado").length} recuperadas)
          </span>
        )}
      </p>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 text-left text-xs text-gray-500 uppercase tracking-wider">
                <th className="px-4 py-2">Nombre</th>
                <th className="px-4 py-2">Servicio</th>
                <th className="px-4 py-2">Cuota</th>
                <th className="px-4 py-2">Fecha baja</th>
                <th className="px-4 py-2">Motivo</th>
                <th className="px-4 py-2">Resultado</th>
                <th className="px-4 py-2">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {bajas.map((baja) => (
                <tr key={baja.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 font-medium text-gray-900 whitespace-nowrap">
                    {baja.nombre || "—"}
                  </td>
                  <td className="px-4 py-2 text-gray-600">
                    {baja.tipo_servicio || "—"}
                  </td>
                  <td className="px-4 py-2 text-gray-600">
                    {fmtMoney(baja.cuota_mensual)}
                  </td>
                  <td className="px-4 py-2 text-gray-600 whitespace-nowrap">
                    {formatDate(baja.fecha_baja)}
                  </td>
                  <td className="px-4 py-2 text-gray-600">
                    {baja.motivo || "—"}
                  </td>
                  <td className="px-4 py-2">
                    {baja.resultado ? (
                      <span
                        className={`inline-flex px-2 py-0.5 text-xs font-medium rounded-full ${
                          baja.resultado === "Recuperado"
                            ? "bg-emerald-100 text-emerald-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {baja.resultado}
                      </span>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td className="px-4 py-2 text-gray-600 max-w-[200px] truncate">
                    {baja.acciones || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
